import React from 'react';
import styled from 'styled-components';
import { truncate } from 'lodash';
import { Link } from 'gatsby';
import Img from 'gatsby-image';
import * as dayjs from 'dayjs';

const Card = styled.div`
  background-color: #fafafa;
  border-radius: 0.5rem;
  overflow: hidden;
  img {
    border-radius: 0.5rem 0.5rem 0 0;
  }
  .title {
    color: ${(props) => props.theme.mainBrandColor} !important;
  }
  .has-text-weight-bold {
    transition: all 0.4s;
    :hover {
      color: ${(props) => props.theme.mainBrandColor} !important;
    }
  }
  .blog-img {
    transition: all 0.7s;
    :hover {
      transform: scale(1.09);
    }
  }
`;

const NewsItem = ({ post }) => (
  <Card className="card">
    <Link to={`/article/${post.slug.current}`}>
      <div className="card-image">
        <Img
          fluid={post.image.asset.fluid}
          alt={post.title}
          className="blog-img"
        />
      </div>
      <div className="card-content">
        <div className="content">
          <h1 className="subtitle is-5">
            {dayjs(post._createdAt).format('MMMM YYYY')}
          </h1>
          <h2 className="has-text-weight-bold">{post.title}</h2>
          <p className="is-size-6 has-text-weight-normal ">
            {truncate(post.description, {
              length: 150,
            })}
          </p>
        </div>
      </div>
    </Link>
  </Card>
);

export default NewsItem;
